import { Record } from 'immutable';
import { getKnowledgeBaseEmptyState } from '../data/KnowledgeBase';
const KnowledgeBaseRecord = Record(getKnowledgeBaseEmptyState());
export default KnowledgeBaseRecord;